import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { CustomOrderHistoryList, OnlineOrderLoadListParams } from '@order/const';
import { OrderActions, OrderSelectors, StateWithOrder } from '@order/data-access';
import { Order, RoutingService, StateUtils, StateWithProcess } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(
    protected store: Store<StateWithOrder>,
    protected processStateStore: Store<StateWithProcess<void>>,
    protected routingService: RoutingService,
  ) {}

  /**
   * Загрузить данные по заказу
   */
  loadOrderDetails(orderCode: string): void {
    this.store.dispatch(
      new OrderActions.OnlineOrderDetailsLoad({
        orderCode,
      }),
    );
  }

  /**
   * Получить данные по заказу с метаинформацией
   */
  getOrderDetailsState(): Observable<StateUtils.LoaderState<Order>> {
    return this.store.pipe(select(OrderSelectors.getOrderDetailsState));
  }

  /**
   * Получить данные по заказу
   */
  getOrderDetails(): Observable<Order> {
    return this.store.pipe(select(OrderSelectors.getOrderDetails));
  }

  /**
   * Очистка данных заказа
   */
  clearOrderDetails(): void {
    this.store.dispatch(new OrderActions.OnlineOrderDetailsClear());
  }

  /**
   * Получить флаг загрузки истории заказов
   */
  getOrderListLoaded(): Observable<boolean> {
    return this.store.pipe(select(OrderSelectors.getOrdersListLoaded));
  }

  /**
   * Получить флаг загрузки истории заказов
   */
  getOrderListLoading(): Observable<boolean> {
    return this.store.pipe(select(OrderSelectors.getOrdersListLoading));
  }

  /**
   * Загрузка списка заказов
   */
  loadOrderList(params: OnlineOrderLoadListParams): void {
    this.store.dispatch(new OrderActions.OrdersListLoad(params));
  }

  /**
   * Получение списка заказов
   */
  getOrderList(): Observable<CustomOrderHistoryList> {
    return this.store.select(OrderSelectors.getOrdersList).pipe(map((orders) => orders as CustomOrderHistoryList));
  }

  /**
   * Очистка списка заказов
   */
  clearOrderList(): void {
    this.store.dispatch(new OrderActions.OnlineOrdersListClear());
  }

  /**
   * Скачать счет для юрлиц
   */
  downloadOrderInvoicePayment(orderId: string, orderCode: string): void {
    this.store.dispatch(new OrderActions.DownloadOrderInvoicePayment({ orderId, orderCode }));
  }

  /**
   * Скачать счет для юрлиц. Статус загрузки
   */
  getOrderInvoicePaymentLoading(orderId: string): Observable<boolean> {
    return this.store.select(OrderSelectors.getOrderInvoicePaymentLoading(orderId));
  }

  /**
   * Повторить заказ
   */
  repeatOrder(orderCode: string): void {
    this.store.dispatch(new OrderActions.OnlineOrderRepeat({ orderCode }));
  }

  /**
   * Повторить заказ. Статус загрузки
   */
  repeatOrderLoadingState(): Observable<boolean> {
    return this.store.select(OrderSelectors.getOrderRepeatLoading());
  }
}
